const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<style>
				input[type="color" i]::-webkit-color-swatch,
				input[type="color" i]::-moz-color-swatch {
					border: 0;
					border-radius: 0.25rem;
				}
			</style>
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="color"
							class="input py-0"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							value="#ffffff"
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-palette fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- InputType MailingAddress {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="color"
									class="input py-0"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									value="#ffffff"
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-palette fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="color"
						class="input py-0"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
						value="#ffffff"
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-palette fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input"
							aria-readonly="true"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input"
									aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
				value="" />
			<div
				id="DISPLAY-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input"
				aria-readonly="true"
				{~D:Record.Macro.ControlAttr~}
			></div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<input
					id="{~D:Record.Macro.RawHTMLID~}"
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					value=""
				/>
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="DISPLAY-FOR-{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.ControlAttr~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-Color',
			DefaultInputExtensions: [ 'Pict-Input-Color' ],
			Template: /*HTML-Partial*/`
			<!-- InputType Color {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-Color',
			Template: /*HTML-Partial*/`
				value="" />
			<div
				id="DISPLAY-TABULAR-FOR-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
